
















































































import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {Mall} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import ReviewTabs from '@/components/product/review/ReviewTabs.vue';
import TuiGrid from 'tui-grid';

import {getToday, addDay} from '@/utils/dateUtils';
import {getProductsConfigurationsByAllMall, convertProductUri} from '@/utils/commonUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {ncpPopup} from '@/utils/ncp';
import {htmlEncode} from '@/utils/formatUtils';

const mallModule = namespace('mall');

@Component({
  components: {
    CompSelectBox,
    PeriodDateCalendar,
    ItemTable,
    RadioElement,
    ReviewTabs,
  }
})
export default class ProductReportList extends Vue {
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private productDetailUrls: any = [];
  private get mallList() {
    let list: any = [
      {
        value: 0,
        name: this.$t('COMMON_ALL')
      }
    ];
    if (this.malls) {
      this.malls.forEach((mall) => {
        if (mall.used) {
          list.push({
            value: mall.mallNo,
            name: mall.mallName
          });
        }
      });
    }
    return list;
  }

  // 등록일
  private startDate: string = addDay(new Date(), -7);
  private endDate: string = getToday();
  private periodOption = {
    period: '1w'
  };

  // 신고사유
  private reportReasonType = 'ALL';
  private reportReasonTypes = [
    {
      value: 'ALL',
      name: 'COMMON_ALL'
    },
    {
      value: 'COPYRIGHT',
      name: 'PRODUCT_REVIEW_REPORT_REASON_TYPE_COPYRIGHT'
    },
    {
      value: 'SLANDER',
      name: 'PRODUCT_REVIEW_REPORT_REASON_TYPE_SLANDER'
    }
  ];

  // 상세검색
  private searchType = 'REGISTER_NAME';
  private searchTypes = [
    {
      value: 'REGISTER_NAME',
      name: 'PRODUCT_REVIEW_MEMBER_NAME'
    },
    {
      value: 'REVIEW_NO',
      name: 'PRODUCT_REVIEW_REVIEW_NO'
    },
    {
      value: 'PRODUCT_NO',
      name: 'PRODUCT_REVIEW_PRODUCT_NO'
    },
    {
      value: 'PRODUCT_NAME',
      name: 'PRODUCT_REVIEW_PRODUCT_NAME'
    }
  ];
  private keyword = '';

  // 상품평 구분
  private reviewType = 'ALL';
  private reviewTypes = {
    name: 'reviewTypes',
    data: [
      {
        id: 'reviewTypes_ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'reviewTypes_NORMAL',
        value: 'NORMAL',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_NORMAL'
      },
      {
        id: 'reviewTypes_BEST',
        value: 'BEST',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_BEST'
      }
    ]
  };

  // 조회
  private size: number = 30;
  private nowPage: number = 1;
  private async search(page: number = 1, size?: number) {
    if (page) {
      this.nowPage = page;
    }
    if (size) {
      this.size = size;
    }
    let request: any = {
      params: {
        startDate: this.startDate,
        endDate: this.endDate,
        page: this.nowPage,
        size: this.size
      }
    };
    if (this.mallNo !== 0) {
      request.params.mallNo = this.mallNo;
    }
    if (this.reportReasonType !== 'ALL') {
      request.params.reportReasonType = this.reportReasonType;
    }
    if (this.keyword !== '') {
      request.params.searchType = this.searchType;
      request.params.keyword = this.keyword;
    }
    if (this.reviewType !== 'ALL') {
      request.params.bestReviewYn = this.reviewType === 'BEST' ? 'Y' : 'N';
    }
    const {data} = await this.$api.getReviewsReports(request);
    this.reports = data.contents.map((item) => {
      let tempReport = JSON.parse(JSON.stringify(item));
      tempReport.content = item.reportContent;
      let member = '';
      if (!item.reporter) {
        member = window.$t('PRODUCT_REVIEW_WRONG_MEMBER');
      } else {
        if (item.reporter.memberStatus === 'EXPELLED') {
          member = window.$t('PRODUCT_REVIEW_WITHDRAWAL_MEMBER');
        }
        member = item.reporter.memberId + '(' + item.reporter.memberNo + ')';
      }
      tempReport.member = member;
      tempReport.mallProductNo = item.productNo;
      return tempReport;
    });
    this.totalCount = data.totalCount;
    this.gridProps.options.pageOptions.page = this.nowPage;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }

  // 초기화
  private reset() {
    this.mallNo = 0;
    (this.$refs.periodCalendar as any).clickPeriod('1w');
    this.reportReasonType = 'ALL';
    this.searchType = 'REGISTER_NAME';
    this.keyword = '';
    this.reviewType = 'ALL';
  }

  // 상품조회결과
  private reports: any = [];
  private totalCount = 0;
  private tableOption = {
    name: 'reportGrid',
    gridName: 'REVIEW_REPORT_GRID',
    haveExcelDownBtn: false,
    onLoadSearch: false
  };
  private gridProps = {
    header: {
      height: 33
    },
    options: {
      columnOptions: {
        resizable: true
      },
      rowHeight: 31,
      bodyHeight: 600,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      minRowHeight: 31,
      keyColumnName: 'reportNo',
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0
      }
    },
    columns: [
      {
        header: 'PRODUCT_REVIEW_HEADER_REPORT_NO',
        name: 'reportNo',
        align: 'center',
        minWidth: 75,
        formatter: (cell: any) => {
          return `<span class="reportNo" data-report-no="${cell.value}" data-review-no="${cell.row.reviewNo}">${cell.value}</span>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_REVIEW_TYPE',
        name: 'bestReviewYn',
        align: 'center',
        minWidth: 120,
        formatter: ({row}: any) => {
          return row.bestReviewYn === 'Y' ? window.$t('PRODUCT_REVIEW_REVIEW_TYPE_BEST') : window.$t('PRODUCT_REVIEW_REVIEW_TYPE_NORMAL');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_MALLNO',
        name: 'mallNo',
        align: 'center',
        minWidth: 100,
        formatter: this.formatMallName,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_REPORT_YMDT',
        name: 'registerYmdt',
        align: 'center',
        minWidth: 150,
        formatter: function ({row}: any) {
          return row.reportDateTime;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_REPORT_REASON',
        name: 'reportReasonLabel',
        align: 'center',
        minWidth: 150,
        formatter: function ({row}: any) {
          return window.$t(`PRODUCT_REVIEW_REPORT_REASON_TYPE_${row.reportReasonType}`);
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_REPORT_CONTENT',
        name: 'content',
        align: 'left',
        minWidth: 280,
        formatter: ({row}: any) => {
          return `<div class="ellipsis">${htmlEncode(row.reportContent)}</div>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_MEMBER_NAME',
        name: 'member',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          if (!cell.row.reporter) {
            return cell.value;
          } else {
            if (cell.row.reporter.memberStatus === 'EXPELLED') {
              return cell.value;
            }
            return `<a href="javascript:;" class="memberPopup" data-member-no="${cell.row.reporter.memberNo}">${cell.value}</a>`;
          }
        }
      },
      {
        header: 'PRODUCT_REVIEW_REVIEW_NO',
        name: 'reviewNo',
        align: 'center',
        minWidth: 75
      },
      {
        header: 'PRODUCT_REVIEW_PRODUCT_NO',
        name: 'mallProductNo',
        align: 'center',
        minWidth: 85,
        formatter: this.formatMallProductNo
      },
      {
        header: 'PRODUCT_REVIEW_PRODUCT_NAME',
        name: 'productName',
        align: 'left',
        minWidth: 200,
        formatter: function (cell: any) {
          return `<div class="ellipsis">${cell.value}</div>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_REVIEW_CONTENT',
        name: 'reviewContent',
        align: 'left',
        minWidth: 250,
        formatter: function (cell: any) {
          return `<div class="ellipsis">${cell.value}</div>`;
        }
      }
    ]
  };
  private formatMallName(cell: any) {
    let mallInfo = this.malls.find((mall: Mall) => mall.mallNo === cell.value);
    if (mallInfo) {
      return mallInfo.mallName;
    }
    return '';
  }
  private formatMallProductNo(cell: any) {
    let tempConfig = this.productDetailUrls.find((item) => item.mallNo === cell.row.mallNo);
    let uri = '';
    if (tempConfig) {
      uri = convertProductUri(tempConfig.productDetailUrl, cell.row.productNo);
    }
    return `<a target="_blank" href="${uri}" >${cell.row.productNo}</a>`;
  }
  private openReportDetailPopup(e: any) {
    let reportNo = $(e.target).data('report-no');
    let reviewNo = $(e.target).data('review-no');
    (window as any).detailCallBack = this.detailCallBack;
    sessionStorage.setItem('reportDetailFrom', 'ReportList');
    ncpPopup(`/review/report/${reportNo}?reviewNo=${reviewNo}`, 'reportDetailPopup', 1000, 800);
  }
  private detailCallBack() {
    (window as any).detailCallBack = undefined;
    sessionStorage.removeItem('reportDetailFrom');
    this.search();
  }
  private onClickMemberPopup(e: any) {
    const memberNo = $(e.target).data('member-no');
    ncpPopup(`/member/popup/crm/${memberNo}`, window.$t('PRODUCT_REVIEW_POP_CRM'), 1100, 980);
  }

  private async mounted() {
    await this.fetchMalls();
    if (this.malls.length === 1) {
      this.mallNo = this.malls[0].mallNo;
    }
    this.productDetailUrls = await getProductsConfigurationsByAllMall();
    await this.search(1);

    $('#wrap').on('click', '.reportNo', $.proxy(this.openReportDetailPopup, this));
    $('#wrap').on('click', '.memberPopup', $.proxy(this.onClickMemberPopup, this));
  }
  private created() {
    let noData = this.$t('PRODUCT_REVIEW_REPORT_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private beforeDestroy(): void {
    let noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
}
